import React from "react";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const TeacherBarchart = (props) => {
    const sdata = [];
    const labels = [];
    const AllResp = [];
    const CorrResp = [];
    for (let i = 0; i < props.Subjectdata?.length; i++) {
        labels.push(props.Subjectdata[i]?.subjectName)
        sdata.push(props.Subjectdata[i]?.[`sec${props.Section}_Pert`])
        AllResp.push(props.Subjectdata[i]?.[`allRespSec${props.Section}`])
        CorrResp.push(props.Subjectdata[i]?.[`correctRespSec${props.Section}`])
    }
    const GetColor = (e) => {
        switch (e) {
            case "English":
                return "#3182BD"
            case "Mathematics":
                return "#049F34"
            case "Biology":
                return "#7C60BC"
            case "Bio-Technology":
                return "#FB8500"
            case "Hindi":
                return "#f96393";
            case "Telugu":
                return "#AD46FF";
            default:
                return "#F9A915"
        }
    }
    const colors = labels.map(l => GetColor(l));
    const data = {
        labels: labels,
        datasets: [
            { data: sdata, backgroundColor: colors, barThickness: 40, }
        ],
    };
    const options = {
        aspectRatio: 3,
        responsive: true,
        plugins: {
            legend: false,
            title: { display: true, text: `Section ${props.Section}`, },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = [];
                        label.push(`${labels[context.dataIndex]} : ${context.parsed.y}%`);
                        label.push(`All Responses : ${AllResp[context.dataIndex]}`);
                        label.push(`Correct Responses : ${CorrResp[context.dataIndex]}`);

                        return label;
                    }
                }
            },
            datalabels: {
                anchor: "end",
                align: "end",
                offset: -5,
                formatter: (value) => {
                    return value;
                },
                font: {
                    size: 12,
                    weight: "bold",
                },
            },
        },
        scales: {
            x: { grid: { display: false, }, },
            y: { max: 100, title: { display: true, text: 'Subject wise%' }, beginAtZero: true, }
        }
    };
    return (<>
        <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={props.Ref} />
    </>
    )
};
export default TeacherBarchart;